import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Delivery.module.css';

function Delivery() {
  const { t } = useTranslation();
  return (
    <section
      id="delivery"
      className={styles.section}
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL || ''}/delivery-bg.png)` }}
    >
      <div className={styles.overlay} />
      <div className={styles.content}>
        <h2 className={styles.heading}>{t('delivery.heading')}</h2>
        <p className={styles.description}>
          {t('delivery.description')}
        </p>
        <p className={styles.subheading}>{t('delivery.subheading')}</p>
        <ul className={styles.list}>
          <li>
            <span className={styles.icon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="3" width="15" height="13" />
                <polygon points="16 8 20 8 23 11 23 16 16 16 16 8" />
                <circle cx="5.5" cy="18.5" r="2.5" />
                <circle cx="18.5" cy="18.5" r="2.5" />
              </svg>
            </span>
            <div>
              <strong>{t('delivery.freeDelivery')}</strong>
              <p>{t('delivery.freeDeliveryDesc')}</p>
            </div>
          </li>
          <li>
            <span className={styles.icon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </span>
            <div>
              <strong>{t('delivery.shortRental')}</strong>
              <p>{t('delivery.shortRentalDesc')}</p>
            </div>
          </li>
          <li>
            <span className={styles.icon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
              </svg>
            </span>
            <div>
              <strong>{t('delivery.airportDelivery')}</strong>
              <p>{t('delivery.airportDeliveryDesc')}</p>
            </div>
          </li>
        </ul>
        <div className={styles.highlight}>
          <span className={styles['highlight-icon']}>!</span>
          <p>
            {t('delivery.highlight')}
          </p>
        </div>
        <p className={styles['delivery-areas']}>
          {t('delivery.areas')}
        </p>
      </div>
    </section>
  );
}

export default Delivery;
